export enum SystemType{
  MainLine = 1,
  SwitchYard
}